import {
  Col as _Col,
  Dialog as _Dialog,
  Loading as _Loading,
  Overlay as _Overlay,
  Row as _Row,
  Popup as _Popup,
  Picker as _Picker,
  Area as _Area,
  List as _List,
  Swipe as _Swipe,
  SwipeItem as _SwipeItem,
  // todo
  Radio as _Radio,
  RadioGroup as _RadioGroup,
  Cell as _Cell,
  CellGroup as _CellGroup,
  Switch as _Switch,
  Stepper as _Stepper
} from '@vivo/shop-ui-h5'
import {
  Dialog as _OsDialog,
  Button as _OsButton,
  ButtonGroup as _OsButtonGroup,
  Switch as _OsSwitch,
  Checkbox as _OsCheckbox,
  CheckboxGroup as _OsCheckboxGroup,
  RadioGroup as _OsRadioGroup,
  Radio as _OsRadio,
  Icon as _OsIcon,
  Tag as _OsTag,
} from '@vivo/vos-ui'

// 业务 组件
import SkuSelect from './sku-select'
import Scroll from './scroll'
import NativeScroll from './scroll/native'
import Icon from './icon'
import Space from './space'
import Tabs from './tabs'
import Padding from './padding'
import CountDown from './count-down'
import Empty from './empty'
import Header from './header'
import HeaderNew from './header-new'
import HeaderPro from './header-pro'
import HeaderMenu from './header-menu'
import Footer from './footer'
import Pending from './pending'
import Page from './page'
import PagePro from './page-pro'
import ImagePreview from './image-preview'
import ImageUpload from './image-upload'
import ProductItem from './product-item'
import ProductItemOrder from './product-item-order'
import ServiceQrCode from './service-qr-code'
import AftServicePop from './aft-service-pop'
import Gift from './gift'
import Coupon from './coupon'
import Recommend from './recommend'
import RecommendList from './recommend-list'
import Popups from './popups'
import VPopups from './vpopups'
import OsPopup from './os-popup'
import OutLink from './out-link'
import Search from './search'
import Ellipsis from './ellipsis'
import Share from './share'
import ListView from './list-view'
import ScrollX from './scroll-x'
import subPage from './sub-page'
import Price from './price'
import PriceAnimate from './price-animate'
import PriceCutIcon from './price-cut-icon'
import PageError from './page-error'
import Input from './input'
import ListLoading from './list-loading'
import ContactGuide from './contact-guide'
import PopupsDialog from './popups-dialog'
import TextareaAutoSize from './textarea-autosize'
import Step from './step'
import Painter from './painter'
import TextExpand from './text-expand'
import addressNew from './address-popups/address-new'
import Checkbox from './adapter-vos/checkbox'
import Radio2 from './radio2'
import Button from './adapter-vos/button'
import SuccessItem from './success-item'
import Rate from './rate'

// 函数组件
import { grouponEndPopup, vbuyEndPopup, vipFirstBuyPopup } from './activity-end-popup'
import LoadingMore from './loading-more'

const Col = _Col
const Dialog = _Dialog
const Loading = _Loading
const Overlay = _Overlay
const Row = _Row
// const Toast = _Toast
const Popup = _Popup
const Picker = _Picker
const Area = _Area
const List = _List
const Swipe = _Swipe
const SwipeItem = _SwipeItem
const Radio = _Radio
const RadioGroup = _RadioGroup
const Cell = _Cell
const CellGroup = _CellGroup
const Switch = _Switch
const Stepper = _Stepper
// 公控组件
const OsDialog = _OsDialog
const OsButton = _OsButton
const OsButtonGroup = _OsButtonGroup
const OsSwitch = _OsSwitch
const OsCheckbox = _OsCheckbox
const OsCheckboxGroup = _OsCheckboxGroup
const OsRadioGroup = _OsRadioGroup
const OsRadio = _OsRadio
const OsIcon = _OsIcon
const OsTag = _OsTag

const components = [
  Col,
  Dialog,
  Empty,
  Loading,
  Overlay,
  Row,
  Icon,
  // Toast,
  Popup,
  VPopups,
  OsPopup,
  Picker,
  Area,
  List,
  Swipe,
  SwipeItem,
  Space,
  Tabs,
  Scroll,
  NativeScroll,
  Padding,
  ImagePreview,
  ImageUpload,
  CountDown,
  Header,
  HeaderNew,
  HeaderPro,
  HeaderMenu,
  Footer,
  Pending,
  Page,
  PagePro,
  ProductItem,
  ProductItemOrder,
  ServiceQrCode,
  AftServicePop,
  Gift,
  Coupon,
  Recommend,
  RecommendList,
  Search,
  Ellipsis,
  Share,
  ListView,
  ScrollX,
  Radio,
  RadioGroup,
  Cell,
  CellGroup,
  Switch,
  Price,
  PriceAnimate,
  PriceCutIcon,
  Stepper,
  Step,
  PageError,
  Input,
  ListLoading,
  ContactGuide,
  PopupsDialog,
  TextareaAutoSize,
  LoadingMore,
  Painter,
  TextExpand,
  addressNew,
  Checkbox,
  Radio2,
  Button,
  SuccessItem,
  Rate
]

const OSComponents = [OsDialog, OsButton, OsButtonGroup, OsSwitch, OsCheckbox, OsRadioGroup, OsRadio, OsCheckboxGroup, OsIcon, OsTag]

const version = '1.0.0'

const install = Vue => {
  components.forEach(Component => {
    Vue.use(Component)
  })
  OSComponents.forEach(Component => {
    Vue.component(Component.name, Component)
  })
}

export {
  install,
  Col,
  Dialog,
  Empty,
  Loading,
  Overlay,
  Row,
  Icon,
  // Toast,
  Space,
  Tabs,
  Scroll,
  NativeScroll,
  Padding,
  Popup,
  Picker,
  Area,
  Swipe,
  SwipeItem,
  SkuSelect,
  ImagePreview,
  ImageUpload,
  CountDown,
  Header,
  Footer,
  Pending,
  Page,
  PagePro,
  ProductItem,
  ProductItemOrder,
  ServiceQrCode,
  AftServicePop,
  Gift,
  Coupon,
  Recommend,
  RecommendList,
  Popups,
  VPopups,
  OsPopup,
  OutLink,
  Search,
  Ellipsis,
  // 函数组件
  grouponEndPopup,
  vbuyEndPopup,
  vipFirstBuyPopup,
  Share,
  subPage,
  Price,
  PriceAnimate,
  PriceCutIcon,
  Stepper,
  Step,
  PageError,
  Input,
  ListLoading,
  ContactGuide,
  PopupsDialog,
  TextareaAutoSize,
  LoadingMore,
  Painter,
  TextExpand,
  addressNew,
  Checkbox,
  Radio2,
  Button,
  SuccessItem,
  Rate
}

export default {
  install,
  version
}
